import React from 'react'

import { NavLink } from 'react-router-dom'

import { makeStyles } from '@material-ui/core/styles'

import clsx from 'clsx'

const useStyles = makeStyles((theme) => ({
	crumbInt: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center'
	},
	crumb: {
		fontFamily: 'Nunito',
		fontSize: 16,
		fontWeight: 'bold',
		textDecoration: 'none',
		color: '#3B0275',
		marginRight: 5,
		opacity: 0.6
	},
	selectedCrumb: {
		fontWeight: 800,
		fontSize: '16px',
		lineHeight: '22px',
		color: theme.palette.primary.main,
		opacity: 1,
		textTransform: 'uppercase'
	}
}))

const SECTION_LABEL = {
	events: 'Events & Specials',
	bar: 'Featured Bar Items',
	friendsOfSkiptown: 'Friends of Skiptown',
	dashNotifications: 'Dash Notifications',
	promos: 'Promos'
}

const FacilityMarketingBreadCrumbs = (props) => {
	const { selectedFacility, location } = props
	const classes = useStyles()

	const facilityId = selectedFacility ? selectedFacility._id : null

	const match = location?.pathname?.match(/facilityMarketing\/([^/]+)/)
	const sectionLabel = match ? SECTION_LABEL[match[1]] : null

	return (
		<div className={classes.crumbInt}>
			<NavLink className={classes.crumb} to={`/facilities/${facilityId}/schedule`}>
				Home /
			</NavLink>
			<NavLink
				className={clsx([classes.crumb, sectionLabel ? {} : classes.selectedCrumb])}
				to={`/facilities/${facilityId}/facilityMarketing/events`}>
				Facility Marketing{sectionLabel && ' /'}
			</NavLink>
			{sectionLabel && (
				<NavLink className={clsx([classes.crumb, classes.selectedCrumb])} to={location.pathname}>
					{sectionLabel}
				</NavLink>
			)}
		</div>
	)
}

export default FacilityMarketingBreadCrumbs
